module.exports = __webpack_public_path__ + "static/media/img2.a59001ab.png";